import styles from './styles.css'
import cn from 'classnames'

const View = ({ doRefreshSearches, isRefreshingSearches }) => {
  return (
    <a
      className={cn(styles.spinner, { [styles.active]: isRefreshingSearches })}
      onClick={doRefreshSearches}
    >
      <span
        className={cn('Icon Icon-refresh', styles.refreshIcon, {
          active: isRefreshingSearches,
        })}
      />
    </a>
  )
}

export default View
